import React, { memo, useMemo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const FilterPlaceholderCDS = ({ width = null }) => {
  const placeholderStyles = useMemo(() => ({ width: width || 'fit-content' }), [width]);

  return <Box sx={placeholderStyles} />;
};

FilterPlaceholderCDS.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default memo(FilterPlaceholderCDS);
